import { render } from "./ContentBrosur.vue?vue&type=template&id=5b035cf6"
import script from "./ContentBrosur.vue?vue&type=script&lang=js"
export * from "./ContentBrosur.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__